import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, mergeMap, switchMap } from 'rxjs/operators';

import { UnitsService } from '../../../../../../../ongoing/src/lib/services/units/units.service';

import * as unitActions from '../actions/units.actions';

@Injectable()
export class UnitsEffects {
  constructor(private actions$: Actions, private unitsService: UnitsService) {}

  units$ = createEffect(() =>
    this.actions$.pipe(
      ofType(unitActions.loadUnits),
      mergeMap(() => {
        return this.unitsService.read().pipe(
          map(
            unit => unitActions.loadUnitsSuccess({ payload: unit }),
            catchError(err => of(unitActions.loadUnitsFail({ payload: err })))
          )
        );
      })
    )
  );

  loadMoreUnits$ = createEffect(() =>
    this.actions$.pipe(
      ofType(unitActions.loadMoreUnits),
      mergeMap(res => {
        return this.unitsService.loadMore(res?.payload?.skip, res?.payload?.limit).pipe(
          map(
            unit => unitActions.loadMoreUnitsSuccess({ payload: unit }),
            catchError(err => of(unitActions.loadMoreUnitsFail({ payload: err })))
          )
        );
      })
    )
  );

  loadAllUnits$ = createEffect(() =>
    this.actions$.pipe(
      ofType(unitActions.loadAllUnits),
      mergeMap(() => {
        return this.unitsService.loadAll().pipe(
          map(
            unit => unitActions.loadAllUnitsSuccess({ payload: unit }),
            catchError(err => of(unitActions.loadAllUnitsFail({ payload: err })))
          )
        );
      })
    )
  );

  searchUnits$ = createEffect(() =>
    this.actions$.pipe(
      ofType(unitActions.searchUnits),
      switchMap(res => {
        return this.unitsService.search(res.payload).pipe(
          distinctUntilChanged(),
          debounceTime(500),
          map(
            unit => unitActions.searchUnitsSuccess({ payload: unit }),
            catchError(err => of(unitActions.searchUnitsFail({ payload: err })))
          )
        );
      })
    )
  );
}
